import { SORT_OPTIONS } from "@/utils/applicationConstants";
import { sharedService } from "@/modules/shared/store/services/shared-service";
import { RECEIVE_GET_PROPERTY_TYPES } from "@/redux/constants/property_types";

const DEFAULT_FILTERS = { page: 1, size: 30, sortBy: SORT_OPTIONS[6].id, searchTerm: "" };

const getPropertyTypes = sharedService.injectEndpoints({
  endpoints: builder => ({
    getPropertyTypes: builder.query({
      query: () => {
        const params = new URLSearchParams();
        Object.entries(DEFAULT_FILTERS).forEach(([k, v]) => { if (v) params.set(k, v); });
        return `parameters/property-types?${params}`;
      },
      transformResponse: response => response.items,
      providesTags: ["PropertyTypes"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch({ type: RECEIVE_GET_PROPERTY_TYPES, propertyTypes: data });
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetPropertyTypesQuery } = getPropertyTypes;

